import { render, staticRenderFns } from "./poolWarn.vue?vue&type=template&id=18a743d2&scoped=true&"
import script from "./poolWarn.vue?vue&type=script&lang=js&"
export * from "./poolWarn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a743d2",
  null
  
)

export default component.exports